module.exports = __webpack_public_path__ + "img/photo-0130.9fa1c103.jpg";